import { atom, selector } from 'recoil'

import { Correct, UseDeviceName } from '@/utils/rtc'

export type LineType = 'agora' | 'zego' | 'trtc'

// 线路
export const roomLineState = atom<LineType>({
  key: 'roomLine',
  default: 'agora'
})

// 是否能切线路
export const canChangeRTCLineState = atom<0 | 1>({
  key: 'canChangeRTCLine',
  default: 0
})

export type Platform =
  // 占位
  | 0
  // 安卓
  | 1
  // iOS
  | 2
  // web
  | 3

export type UserType =
  // 占位
  | 0
  // 老师
  | 1
  // 学生
  | 2
  // 监课
  | 3
  //控制
  | 4
  //家长
  | 5

export interface RtmUser {
  addrIP: string // ip地址
  deviceName: string // 设备型号
  exVideoId: number // 外接摄像头视频id(PC端使用)
  userName: string // 用户昵称
  userType: UserType // 用户身份
  data: string // 自定义信息 为了 ，兼容监课对于客户端1.4.7兼容，客户端没有1.4.7就可以去掉
  platform: Platform // 设备平台
  userId: string
  changeLine: number //版本号300
  isPhone: boolean //是否手机端
  sl: string // 线路
}

// rtm对方信息
export const rtmUserState = atom<RtmUser | null>({
  key: 'rtmUser',
  default: null
})

export type UseDevice = Record<UseDeviceName, string>

export interface ParamsType {
  // 上课日期 "2023-06-02"
  date?: string | null
  // 1 老师 2 学生
  type: number
  // 老师ID 入参的 userid 不带10
  teacherId: number
  // 房间号 入参的 roomCode
  roomId: string
  // 开始到结束13位时间戳 "1685689584000-1685693184000"
  timesRange?: string | null
  // 通过 timesRange 转化的开始10时间戳
  datetime: number
  lessonId: number
  // 课程类型 1:试听、2:正式（教室外 0:试听、1:正式 进入教室时服务端会设置成 1:试听、2:正式）
  lessonType: number
  // 时段ID
  lessonTimeId: number
  // 心跳
  heartBeatRate: number
  // 学员ID 不带20
  studentId: number
  // 学员头像
  studentHead?: string | null
  // 课件ID
  courseId: number
  // 学生名称
  studentName?: string | null
  // 是否临时课堂，根据房间号长度判断
  isTempClass: boolean
  // 带10前缀的老师ID字符串 - 主镜头ID
  mainTeacherId: string
  // 带11前缀的老师ID字符串 - 副镜头ID
  viceTeacherId: string
  // 带12前缀的老师ID字符串 - just镜头ID
  justTeacherId: string
  // 带20前缀的学员ID字符串 - 主镜头ID
  mainStudentId: string
  // 带21前缀的学员ID字符串 - 副镜头ID
  viceStudentId: string
  // 带22前缀的学员ID字符串 - just镜头ID
  justStudentId: string
}

export const defParams = {
  date: '',
  type: 0,
  teacherId: 0,
  roomId: '',
  timesRange: '',
  datetime: 0,
  lessonId: 455075,
  lessonType: 0,
  lessonTimeId: 0,
  heartBeatRate: 0,
  studentId: 0,
  studentHead: '',
  courseId: 0,
  studentName: '',
  isTempClass: false,
  mainTeacherId: '',
  viceTeacherId: '',
  justTeacherId: '',
  mainStudentId: '',
  viceStudentId: '',
  justStudentId: ''
}

// 默认矫正信息
export const defaultPos = {
  topLeft: { infoY: 0, infoX: 0 },
  topRight: { infoY: 0, infoX: 1 },
  bottomLeft: { infoY: 1, infoX: 0 },
  bottomRight: { infoY: 1, infoX: 1 },
  flip: false,
  mirror: false
}

// 入参
export const paramsState = atom<ParamsType>({
  key: 'params',
  default: defParams
})

export interface PlansInfo {
  lable: string
  diff: string
  section: string
  id: number
  title: string
  url: string
  age: string
}

export interface WorksInfo {
  workUrl: string // 作品图片url
  workDate: string // 作品日期
}

export interface BasicInfo {
  sex: string
  birth: number
  language: string
  artsBasic: string
  userName: string
  userId: number
  userAge: number
  master: number
  head: string
  character: string
  userHead: string
  interest: string
  wishStudy: string
  region: string
  plansInfo: PlansInfo[]
  worksInfo: WorksInfo[]
}

// 用户信息
export const basicInfoState = atom<BasicInfo | null>({
  key: 'basicInfo',
  default: null
})

// 选中的设备 - 没有依次取系统的
export const useDeviceState = atom<UseDevice>({
  key: 'useDevice',
  default: {
    mainCamera: '',
    viceCamera: '',
    microphone: '',
    playback: ''
  }
})

// 房间是否准备好了，这个状态在房间加载完成并所有子页面的第一个生命周期结束后置为true
// 这个状态可以用于避免子页面第一个useEffect作用的判断逻辑
export const roomReadyState = atom({
  key: 'roomReady',
  default: false
})

// 透视矫正状态
export const correctionState = atom({
  key: 'correction',
  default: false
})

export interface CorrectInfo {
  userId: string
  status: Correct
  topLeft: { infoY: number; infoX: number }
  topRight: { infoY: number; infoX: number }
  bottomLeft: { infoY: number; infoX: number }
  bottomRight: { infoY: number; infoX: number }
  flip: boolean
  mirror: boolean
}

// 透视矫正
export const correctInfoListState = atom<{ [key: string]: CorrectInfo }>({
  key: 'correctInfoList',
  default: {}
})

export interface TeacherVideoInfo {
  bigWindowId: string
  mode: string
  screenY: number
  twiceVideoY: number
  userId: number
  videoY: number
}

// 屏幕模式老师
export const teacherVideoInfoState = atom<TeacherVideoInfo | null>({
  key: 'teacherVideoInfo',
  default: null
})

// 老师小屏幕信息 0 默认小屏模式、1 全屏模式、2 收起
export const teacherSmallVideoInfoState = atom<number>({
  key: 'teacherSmallVideoInfo',
  default: 0
})

// 打点频率
export const dotFrequencyState = atom<number | null>({
  key: 'dotFrequency',
  default: null
})

export type BigWin = 1 | 2 | 3 | 4 | 5

// 1课件 2老师b 3学员a 4学员b 老师a默认左侧大屏
export const bigWinState = atom<BigWin>({
  key: 'bigWin',
  default: 1
})

// 是否点击了老师a大屏，用于画笔权限
export const bigTeaAScreenState = atom<boolean>({
  key: 'bigTeaAScreen',
  default: false
})

// 大屏的id,课件大屏时为空
export const bigWinIdState = selector<string>({
  key: 'bigWinId',
  // get支持异步
  get: ({ get }) => {
    const bigWin = get(bigWinState)
    const params = get(paramsState)
    let id = ''
    switch (bigWin) {
      case 2:
        id = params.mainTeacherId
        break
      case 3:
        id = params.viceTeacherId
        break
      case 4:
        id = params.mainStudentId
        break
      case 5:
        id = params.viceStudentId
        break
      default:
        id = ''
        break
    }
    return id
  }
})

// 模式 normal 互看 active 同屏(霸屏) classPage 课件
export type SyncState = 'normal' | 'active' | 'classPage'

// 模式
export const syncStateState = atom<SyncState>({
  key: 'syncState',
  default: 'normal'
})

export interface JustUser {
  userId: string // 10xxx,20xxx
  isSelected: boolean
}
// userId // 10xxx,20xxx
export const justUserState = atom<{ [userId: string]: boolean }>({
  key: 'justUser',
  default: {}
})

export interface BreadInClassInfo {
  picUrl?: string
  courseIndex: number
  customStartTime: number
  restSwitch: number
  customDuration: number
  startTime: number
  endTime: number
}

export interface Rest {
  onceRest: boolean
  /* 课间休息状态 0 未进行 1开始休息 2结束休息 */
  state: number
  previewCourse: boolean
  clockNum: number
  attendClassState: boolean
  teaPic: string
  restCoursePicId: string
}

// 服务端返回课间休息信息
export const breadInClassInfoState = atom<BreadInClassInfo>({
  key: 'breadInClassInfo',
  default: {
    picUrl: '',
    courseIndex: 0,
    customStartTime: 0,
    restSwitch: 1,
    customDuration: 0,
    startTime: 0,
    endTime: 0
  }
})

// 课间休息
export const restState = atom<Rest>({
  key: 'rest',
  default: {
    onceRest: false, // 24分钟到25分钟，老师截图阶段
    state: 0, // 课间休息状态 0 未进行 1开始休息 2结束休息
    previewCourse: false, // 课间休息查看课件
    clockNum: 0, // 课间休息时间，600->0秒
    attendClassState: false, // 倒计时最后30秒，准备上课
    teaPic: '', // 课间休息老师画面截图
    restCoursePicId: '' // 课间休息截图id,取图片名
  }
})

// 上传图片 涉黄涉政检验 失败弹框
// 空字符串表示无
export const pictureViolationState = atom<string>({
  key: 'pictureViolation',
  default: ''
})

// 鉴黄老师提醒弹框
// 0:未违规 1:提醒 2:踢出
export const videoViolationState = atom<0 | 1 | 2>({
  key: 'videoViolation',
  default: 0
})

// 语音违规弹窗
// state 0:未违规 1:老师 2:学生
// time 最新违规时间
export const soundViolationState = atom({
  key: 'soundViolation',
  default: {
    state: 0,
    time: 0
  }
})

export type WinTeaId = 'mainTeacher' | 'justTeacher' | 'viceTeacher'
export type WinStuId = 'mainStudent' | 'justStudent' | 'viceStudent'
export type WinTeaName = Record<WinTeaId, number>
export type WinStuName = Record<WinStuId, number>
// 视频推流情况(不能做为是否在线的依据，是否在线请使用isStuOnline)
// 0 未推流 1已推流 2已关闭
export const videoLiveTeaState = atom<WinTeaName>({
  key: 'videoLiveTea',
  default: {
    mainTeacher: 2,
    viceTeacher: 2,
    justTeacher: 2
  }
})
export const videoLiveStuState = atom<WinStuName>({
  key: 'videoLiveStu',
  default: {
    mainStudent: 0,
    viceStudent: 0,
    justStudent: 0
  }
})

// 音频推流情况
export const audioLiveState = atom({
  key: 'audioLive',
  default: {
    mainTeacher: false,
    mainStudent: false
  }
})

// 学员是否在后台运行
export const enterBackgroundControlState = atom({
  key: 'enterBackgroundControl',
  default: false
})

// 学员是否在线(根据rtm加入房间判断)
export const isStuOnlineState = atom({
  key: 'isStuOnline',
  default: false
})

// 老师是否在线(根据rtm加入房间判断)
export const isTeaOnlineState = atom({
  key: 'isTeaOnline',
  default: false
})

// 绘画五步法是否确认
export const drawMethodState = atom({
  key: 'drawMethod',
  default: false
})

// 绘画五步法未确认弹窗
export const drawMethodModalState = atom({
  key: 'drawMethodModal',
  default: false
})

// 屏幕共享开关
export const screenSharingState = atom({
  key: 'useScreenSharing',
  default: false
})

// 课堂窗口 状态 0 - 默认全屏 1 - 1X，2 - 2X， 3 - 侧吸
export type RoomWindowType = 'full' | '1X' | '2X' | 'leftSide'

export const roomWindowScaleState = atom<RoomWindowType>({
  key: 'roomWindowScale',
  default: 'full'
})

// rtm状态
export const rtmReadyState = atom({
  key: 'rtmReady',
  default: false
})

export interface MiaobiMenu {
  id?: number
  title?: string
  subTitle?: string
  icon?: string
  sorted?: number
  jumpUrl?: string
  url?: URL
  stuUrl?: URL
  urlKey?: string[]
  load?: boolean // 是否加载
  selectIndex?: string // 选中的索引

  // currentUrl: string
  // currentStuUrl: URL
}

// 妙笔菜单
export const miaobiMenuState = atom<MiaobiMenu[]>({
  key: 'miaobiMenu',
  default: []
})
